<template>
  <div>
    <avatar-selection-component></avatar-selection-component>
    <landing-component></landing-component>
    <welcome-dialog-component></welcome-dialog-component>
    <after-welcome-dialog-component></after-welcome-dialog-component>

    <product-selection-dialog-component></product-selection-dialog-component>
    <test-selection-dialog-component></test-selection-dialog-component>

    <pre-test-dialog-component></pre-test-dialog-component>
    <test-dialog-component></test-dialog-component>

    <dialog-CTA-component></dialog-CTA-component>

    <babylon-component></babylon-component>
  </div>
</template>

<script>
import AvatarSelectionComponent from "@/components/AvatarSelectionComponent.vue";
import LandingComponent from "@/components/LandingComponent.vue";
import WelcomeDialogComponent from "@/components/dialogs/welcomeComponent.vue";
import AfterWelcomeDialogComponent from "@/components/dialogs/afterWelcomeComponent.vue";

import productSelectionDialogComponent from "@/components/dialogs/productSelectionComponent.vue";
import testSelectionDialogComponent from "@/components/dialogs/testSelectionComponent.vue";

import PreTestDialogComponent from "@/components/dialogs/preTestComponent.vue";
import TestDialogComponent from "@/components/dialogs/testComponent.vue";

import DialogCTAComponent from "@/components/dialogs/dialogCTAComponent.vue";

import BabylonComponent from "@/components/BabylonComponent.vue";

export default {
  name: "ItemViewerView",
  components: {
    AvatarSelectionComponent,
    LandingComponent,
    WelcomeDialogComponent,
    AfterWelcomeDialogComponent,
    productSelectionDialogComponent,
    testSelectionDialogComponent,
    PreTestDialogComponent,
    TestDialogComponent,
    DialogCTAComponent,
    BabylonComponent,
  },
};
</script>
<style lang="scss" scoped></style>
